const about = [
    { 
        id: 0,
        year: "1995",
        description: "Established by Mr G.Padmanabhan, also known as Mr G.P in the industry, as a maintenance and repair service provider of high-end medical imaging and radiation oncology equipments with only 2 employees",
    },
    { 
        id: 1,
        year: "1996",
        description: "Entered into the Indian market for selling products representing the brands of Shimadzu and Mitsubishi and providing direct maintenance contracts to major clients’ medical equipments",
    },
    { 
        id: 2,
        year: "1997",
        description: "Signed up an exclusive agreement with Fibretek Developments, South Africa to represent the innovative product CTSP – Frameless Steriotactic Device for neurosurgery",
    },
    { 
        id: 3,
        year: "1999",
        description: "Signed up an agreement with GEEVI Control Systems for manufacturing an in-house brand of Servo Stabilizers and UPS",
    },
    { 
        id: 4,
        year: "2000",
        description: "The Indelect team grew to a size of 15 members, establishing 15 installations of CTSP and encompasses a customer base of 500",
    },
    { 
        id: 5,
        year: "2003",
        description: "Signed up exclusive agreement with Nuclear Power Institute of China for a complete range of Radiation Oncology Solutions",
    },
    { 
        id: 6,
        year: "2006",
        description: "First break through telecobalt installation at Christian Cancer Centre Ambilikai, Tamil Nadu",
    },
    { 
        id: 7,
        year: "2007",
        description: "Touching around 50 users target of CTSP Third Cobalt installed in Sri Durga Clinic & Research Centre, Ponnamaravathi, Tamil Nadu First HDR Brachyatheraphy Unit delivered at Christian Fellowship Community Health Centre, Ambilikai",
    },
    { 
        id: 8,
        year: "2008",
        description: "Reached about 40 users of CTSP all over India Reached an amount of 30 Shimandzu High Frequency X-Ray users in Tamil Nadu Rewarded the ISO9001: 2000 certificate for quality management system by TUV",
    },
    { 
        id: 9,
        year: "2009",
        description: "Touching around 50 users target of CTSP Third Cobalt installed in Sri Durga Clinic & Research Centre, Ponnamaravathi, Tamil Nadu First HDR Brachyatheraphy Unit delivered at Christian Fellowship Community Health Centre, Ambilikai",
    },
    { 
        id: 10,
        year: "2010",
        description: "Signed up an exclusive dealership with Genoray, Korea to represent their Mobile surgical C-Arm all over India",
    },
    { 
        id: 11,
        year: "2014",
        description: "Purchased patent rights for manufacturing of Cape Town Stereotactic Pointing Device (Device) from Cape Town University, South Africa",
    },
    { 
        id: 12,
        year: "2018",
        description: "Acquired AERB Authorisation for sales and services for Diagnostic Radiology Equipments.",
    },
    { 
        id: 13,
        year: "2021",
        description: "Added PIXXGEN DR (Flat Panel Detector) panels for both human and veterinary categories to our product portfolio",
    }
];

export default about;